import * as React from "react";
const SvgFiRrHeartRate = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M24 12a1 1 0 0 1-1 1h-2.466c-.452 0-.849.305-.966.74l-1.677 6.242C17.7 20.607 17.166 21 16.55 21h-.017a1.38 1.38 0 0 1-1.324-1.014L11.935 6.76 8.757 18c-.191.596-.69.975-1.28.998-.612.033-1.119-.315-1.345-.862l-1.6-4.474A1.005 1.005 0 0 0 3.59 13H1a1 1 0 1 1 0-2h2.591c1.264 0 2.398.8 2.825 1.99l.938 2.625L10.638 4c.201-.625.727-1.027 1.361-1a1.385 1.385 0 0 1 1.315 1.012l3.259 13.166 1.062-3.956A3.004 3.004 0 0 1 20.532 11h2.466a1 1 0 0 1 1 1z"
    />
  </svg>
);
export default SvgFiRrHeartRate;
